export default __webpack_public_path__ + "static/media/tickIcon.93785084.png";